/**
 * @author yly
 * @date 2023-08-18
 * @desc 查看标签
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import { Row, Col } from 'antd';
import createColumns from "./columns";
import contentColumn from "./contentColumn";
import "./index.less";

const { WizContainer, modelUtils, ossFileUtils } = framework_tool;
const { WizSpin, WizCard, WizEmpty, WizInput, WizRow, WizCol, WizTabs, WizModal, WizSearchBar, WizIcon, WizDataTable } = component_tool;
const { getPageData } = utils_tool;

import { getDetailRecord } from '@/containers/content/util'

class ContentView extends WizContainer {
  componentName = "ContentView";

  constructor(props) {
    super(props);
    this.state = {
      record: {},
      checkArr: [],
      andOrList: [[0, 0, 0, 0, 0]],
      beforeRecords: {}
    };
    this.detailInfo = getDetailRecord(props.history);
  }

  _componentDidMount() {
    this.doAction({
      path: "label/getById",
      payload: {
        key: "getById",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    detailInfo: this._detailInfo.bind(this),
  };
  _formatData = (conditionList = [], conditionGroupList = []) => {
    return conditionList.map(val => ({
      ...val,
      isGroup: false,
      conditionActionType: 1,
    })).concat(conditionGroupList.map((val, index) => ({
      ...val,
      isGroup: true,
      conditionActionType: 1,
      children: val.children && val.children.length ? val.children.map(val => ({ ...val, pIndex: conditionList.length + index })) : undefined
    })))
  }
  _detailInfo(nextProps, nextState) {
    const { detailInfo } = nextProps;
    if (detailInfo["success"] && detailInfo["data"]) {
      let data = detailInfo.data
      data.records = detailInfo.data?.list
      console.log(data.records,'data.records')
      let aoList=[]
      data?.beforeCondition?.conditionGroupList?.length>0&&data.beforeCondition.conditionGroupList.forEach(item=>{
        aoList.push(item.conditionType)
      })
      console.log(aoList,'aoList')
      nextState.andOrList=aoList
      if (data.beforeCondition) {
        const _records = this._formatData(data.beforeCondition.conditionList, data.beforeCondition.conditionGroupList)
        let arr = []
        _records.forEach(item => {
          item.children?.length > 0 && item.children.forEach(cItem => {
            arr.push(cItem)
          })
        })
        let checked = []
        arr.forEach(item => {
          if (checked.findIndex(x => x == item) == -1) {
            checked.push(item.conditionBizType)
          }
        })
        console.log([...new Set(checked)],'[...new Set(checked)]')
        nextState.checkArr = [...new Set(checked)]
        nextState.beforeRecords = { records: arr }
      }
      nextState.record = JSON.parse(JSON.stringify(data));
      return true;
    } else {
      wizNotice.error(detailInfo['msg'] || "获取数据失败请稍后在试")
    }
    return false;
  }


  _render() {
    const { labelLoading } = this.props;
    const { record, checkArr, beforeRecords } = this.state;
    let { name, categoryFullName, code, state, tear, source, intro } = record

    let dataItems = getPageData(record);
    let beforeDataItems = getPageData(beforeRecords)
    let other = {}
    let columns = contentColumn(this, dataItems, other);

    let dataTableProps = {
      columns,
      rowKey: "personId",
      dataItems,
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.getStudentPathList({ current: pageNum, size: pageSize });
      }
    }
    formatAndOr = (index) => {
      let { andOrList } = this.state
      if (andOrList[index+1] == '0') {
        return '与'
      } else {
        return '或'

      }
    }
    renderItem = (item, index, checkArr) => {
      let title = ''
      if (item == 0) {
        title = '在线课程'
      } else if (item == 8) {
        title = '培训主题'
      } else if (item == 1) {
        title = '考试'
      } else if (item == 30) {
        title = '作业'
      } else if (item == 12) {
        title = '路径'
      }
      const formatDataItems = (item) => {
        let items = { ...beforeDataItems }
        let list = beforeDataItems.list.filter(x => x.conditionBizType == item)
        items.list = list
        return items
      }

      const beforeDataTableProps = {
        key: new Date(),
        loading: labelLoading,
        style: { marginTop: 15, minHeight: 150 },


        rowKey: 'rowId',
        isScroll: true,
        defaultExpandAllRows: true
      }

      return (
        <div className="view-label-out-box" >
          <div className="preconditions-item-inner-box">
            <div className='title-box'>
              <div>{title}</div>
            </div>
            <div className='content-box'>
              <WizDataTable {...beforeDataTableProps} dataItems={formatDataItems(item)} columns={createColumns.call(this, formatDataItems(item), item)} />
            </div>
            {checkArr.length - 1 == index ?
              null :
              <div className="and-or-out">
                <div className="and-or-inner">
                  <span> {formatAndOr(index)}</span>
                </div>
              </div>}
          </div>
        </div>
      )
    }
    return (
      <WizSpin spinning={labelLoading}>
        <WizCard title="标签信息" className='view-label-card-box'>
          <Row>
            <Col className="view-left-title" span={4}>标签名称：</Col>
            <Col span={8}>{name}</Col>
            <Col className="view-left-title" span={4}>标签分类：</Col>
            <Col span={8}>{categoryFullName}</Col>
          </Row>
          <Row>
            <Col className="view-left-title" span={4}>标签编码：</Col>
            <Col span={8}>{code}</Col>
            <Col className="view-left-title" span={4}>标签状态：</Col>
            <Col span={8}>{state == 0 ? '无效' : '有效'}</Col>
          </Row>
          <Row>
            <Col className="view-left-title" span={4}>是否撕除标签：</Col>
            <Col span={8}>{tear == 0 ? '否' : '是'}</Col>
            <Col className="view-left-title" span={4}>标签来源：</Col>
            <Col span={8}>{source == 0 ? '系统' : '其他'}</Col>
          </Row>
          <Row>
            <Col className="view-left-title" span={4}>标签描述：</Col>
            <Col span={8}>{intro}</Col>
            <Col className="view-left-title" span={4}></Col>
            <Col span={8}></Col>
          </Row>
        </WizCard>
        <WizCard>
          <WizTabs animated={false} >
            <WizTabs.TabPane tab="标签规则" key={0}>
              {checkArr.map((item, index) => {
                return (
                  <>
                    {renderItem(item, index, checkArr)}
                  </>
                )
              })}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab="推荐内容" key={1}>
              <WizDataTable {...dataTableProps} />
              {/* <div className="pagination">
                <WizDataTable.Pagination {...dataTableProps} />
              </div> */}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { label } = state;
  const detailInfo = modelUtils.getModelEntity(label, "getById");
  const load = modelUtils.getLoadingState(state, "label");
  return {
    detailInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(ContentView);
